<template>
  <div class="row mb-3 p-0">
    <!-- Een <label for> hoort bij precies één control. Veldtypes die meerdere
         controls bevatten (radio, checkbox) of zichzelf al labelen, krijgen hier
         een <span> met dezelfde tekst; het kindcomponent verwijst ernaar met
         aria-labelledby. Zo blijft de kolomindeling intact en is de naam toch
         programmatisch gekoppeld — een <label> zonder control is zelf een fout. -->
    <label
      v-if="element.label && !isGroepLabel"
      :id="ids.label"
      :for="ids.input"
      :class="labelColClass"
      :hidden="hidden"
    >{{ element.label[lang] }}<span v-if="element.required" aria-hidden="true">*</span><span
        v-if="element.required" class="visually-hidden"> (verplicht)</span></label>

    <span
      v-else-if="element.label"
      :id="ids.label"
      :class="labelColClass"
      :hidden="hidden"
    >{{ element.label[lang] }}<span v-if="element.required" aria-hidden="true">*</span><span
        v-if="element.required" class="visually-hidden"> (verplicht)</span></span>
    <div v-if="element.type == 'p'" class="col-12">
      <FormElementBodyText :element="element" :lang="lang" :ids="ids" :hidden="hidden" />
    </div>
    <div v-if="'text|date|time|datetime-local'.indexOf(element.type) >= 0" :class="inputColClass">
      <FormElementTextInput @elementChanged="(name, data) => $emit('elementChanged', name, data)" :formData="formData"
        :value="formData[element.name]" :element="element" :lang="lang" :targetId="targetId"
        :wasValidated="wasValidated" :ids="ids" :hidden="hidden" />
    </div>
    <div v-if="'txtarea'.indexOf(element.type) >= 0" :class="inputColClass">
      <FormElementTextareaInput @elementChanged="(name, data) => $emit('elementChanged', name, data)"
        :formData="formData" :value="formData[element.name]" :element="element" :lang="lang" :targetId="targetId"
        :wasValidated="wasValidated" :ids="ids" :hidden="hidden" />
    </div>
    <div v-if="'number'.indexOf(element.type) >= 0" :class="inputColClass">
      <FormElementNumberInput @elementChanged="(name, data) => $emit('elementChanged', name, data)" :formData="formData"
        :value="formData[element.name]" :element="element" :lang="lang" :targetId="targetId"
        :wasValidated="wasValidated" :ids="ids" :hidden="hidden" />
    </div>
    <div v-if="'amount'.indexOf(element.type) >= 0" :class="inputColClass">
      <FormElementAmountInput @elementChanged="(name, data) => $emit('elementChanged', name, data)" :formData="formData"
        :value="formData[element.name]" :element="element" :lang="lang" :targetId="targetId"
        :wasValidated="wasValidated" :ids="ids" :hidden="hidden" />
    </div>
    <div v-if="element.type == 'email'" :class="inputColClass">
      <FormElementEmailInput @elementChanged="(name, data) => $emit('elementChanged', name, data)" :formData="formData"
        :valueObj="formData[element.name]" :element="element" :lang="lang" :targetId="targetId"
        :wasValidated="wasValidated" :ids="ids" :hidden="hidden" />
    </div>
    <div v-if="'select'.indexOf(element.type) >= 0" :class="inputColClass">
      <FormElementSelect @elementChanged="(name, data) => $emit('elementChanged', name, data)" :formData="formData"
        :element="element" :lang="lang" :targetId="targetId" :wasValidated="wasValidated" :ids="ids" :hidden="hidden" />
    </div>
    <div v-if="'checkbox'.indexOf(element.type) >= 0" :class="inputColClass">
      <FormElementCheckbox @elementChanged="(name, data) => $emit('elementChanged', name, data)" :formData="formData"
        :element="element" :lang="lang" :targetId="targetId" :wasValidated="wasValidated" :ids="ids" :hidden="hidden" :formVersion="formVersion"/>
    </div>
    <div v-if="element.type === 'legalCheckbox'" :class="inputColClass">
      <FormElementLegalCheckbox @elementChanged="(name, data) => $emit('elementChanged', name, data)" :formData="formData"
        :element="element" :lang="lang" :targetId="targetId" :wasValidated="wasValidated" :ids="ids" :hidden="hidden" />
    </div>
    <div v-if="'radioButton'.indexOf(element.type) >= 0" :class="inputColClass">
      <FormElementRadioButton @elementChanged="(name, data) => $emit('elementChanged', name, data)" :formData="formData"
        :element="element" :lang="lang" :targetId="targetId" :wasValidated="wasValidated" :ids="ids" :hidden="hidden" />
    </div>
    <div v-if="'geo'.indexOf(element.type) >= 0" :class="inputColClass">
      <FormElementGeo @elementChanged="(name, data) => $emit('elementChanged', name, data)" :formData="formData"
        :element="element" :lang="lang" :targetId="targetId" :wasValidated="wasValidated" :ids="ids" :hidden="hidden" />
    </div>
    <div v-if="element.type === 'co2'" :class="inputColClass">
      <FormElementCO2 @elementChanged="(name, data) => $emit('elementChanged', name, data)" :formData="formData"
        :element="element" :lang="lang" :targetId="targetId" :wasValidated="wasValidated" :ids="ids" :hidden="hidden" />
    </div>
  </div>
</template>

<script>
import FormElementTextInput from './SFormElementTextInput.vue';
import FormElementTextareaInput from './SFormElementTextareaInput.vue';
import FormElementNumberInput from './SFormElementNumberInput.vue';
import FormElementAmountInput from './SFormElementAmountInput.vue';
import FormElementEmailInput from './SFormElementEmailInput.vue'
import FormElementSelect from './SFormElementSelect.vue'
import FormElementCheckbox from './SFormElementCheckbox.vue'
import FormElementLegalCheckbox from './SFormElementLegalCheckbox.vue'
import FormElementRadioButton from './SFormElementRadioButton.vue'
import FormElementBodyText from './SFormElementBodyText.vue'
import FormElementGeo from './SFormElementGeo.vue'
import FormElementCO2 from './SFormElementCO2.vue'
import { makeFieldIds } from '../../utils/fieldIds'
export default {
  name: 'FormElement',
  props: ['element', 'targetId', 'pageIndex', 'elementIndex', 'lang', 'formData', 'wasValidated', 'hidden', 'formVersion', 'defaultLabelPosition'],
  emits: ['editFormElement', 'elementChanged'],
  components: {
    FormElementTextInput, FormElementEmailInput, FormElementSelect, FormElementCheckbox, FormElementLegalCheckbox,
    FormElementRadioButton, FormElementBodyText, FormElementNumberInput, FormElementAmountInput,
    FormElementTextareaInput, FormElementGeo, FormElementCO2
  },
  computed: {
    /**
     * Eén afleiding van de id's, hier berekend en als prop doorgegeven. Zouden
     * label en input elk hun eigen id afleiden, dan kunnen ze uit elkaar lopen —
     * precies wat er gebeurde met de hardgecodeerde `for="colFormLabel"`.
     */
    ids() {
      return makeFieldIds(this.element?.name);
    },
    /** Veldtypes zonder één enkele control om een <label for> aan te hangen. */
    isGroepLabel() {
      return ['p', 'checkbox', 'radioButton', 'legalCheckbox', 'geo', 'co2'].includes(this.element?.type);
    },
    effectiveLabelPosition() {
      return this.element.labelPosition || this.defaultLabelPosition || 'left'
    },
    labelColClass() {
      return this.effectiveLabelPosition === 'top'
        ? 'col-12 col-form-label'
        : 'col-sm-2 col-form-label col-form-label-md'
    },
    inputColClass() {
      return this.effectiveLabelPosition === 'top' ? 'col-12' : 'col-sm-10'
    }
  },
  methods: {
    isRequired(value) {
      return value ? "*" : "";
    },
    sendEvent(event) {
      this.$emit(event, this.targetId);
    },
    isHidden(element) {
      console.log("isHidden: ", element)
      return element.hidden
    }
  },
  created() {
  }
}
</script>
